import {
  InputWithIconProps,
  InputWithIcon,
} from 'components/input-with-icon/input-with-icon';
import { Locked, Unlocked } from '@carbon/react/icons';

export interface LockableInputProps extends Omit<
  InputWithIconProps,
  'icon' | 'onIconClick'
> {
  isLocked: boolean;
  onToggleLock: () => void;
}

export const LockableInput = ({
  isLocked,
  onToggleLock,
  disabled = false,
  ...props
}: LockableInputProps) => {
  return (
    <InputWithIcon
      icon={isLocked ? <Locked /> : <Unlocked />}
      disabled={isLocked || disabled}
      onIconClick={onToggleLock}
      {...props}
    />
  );
};
